import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { errorReporter, type ClientStage } from './utils/errorReporter'

// ------ errorReporter 초기화 (앱 마운트 전에 1회 호출) ------
// `stage`는 샘플링 로직 분기(development=0%)에만 사용됨. 서버로 전송되지 않음.
// 배포 환경은 서버가 자신의 NODE_ENV에서 권위적으로 결정.
const stage: ClientStage =
  (process.env.REACT_APP_STAGE as ClientStage | undefined) ?? 'development'
const endpoint =
  process.env.REACT_APP_CLIENT_ERROR_ENDPOINT ||
  process.env.REACT_APP_GRAPHQL_URI ||
  'http://localhost:3100/graphql'

errorReporter.init({
  endpoint,
  enabled: process.env.REACT_APP_CLIENT_ERROR_ENABLED === 'true',
  stage,
  release: process.env.REACT_APP_BUILD_SHA || 'local',
  appName: 'grip-merchant-admin',
})

// window 전역 에러 캡처
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    errorReporter.capture(event.error ?? new Error(event.message), {
      source: 'WINDOW_ERROR',
    })
  })

  window.addEventListener('unhandledrejection', (event) => {
    errorReporter.capture(
      event.reason ?? new Error('Unhandled promise rejection'),
      {
        source: 'UNHANDLED_REJECTION',
      }
    )
  })

  // 페이지 언로드/탭 전환 시 배치 큐 flush (sendBeacon 경로)
  const flushOnHide = () => {
    if (document.visibilityState === 'hidden') {
      void errorReporter.flush()
    }
  }
  window.addEventListener('visibilitychange', flushOnHide)
  window.addEventListener('pagehide', () => {
    void errorReporter.flush()
  })
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
